export default {
      id: "i-info-advantages-03-usage",
      viewBox: "0 0 32 25",
      url: __webpack_public_path__ + "img/sprite.svg#i-info-advantages-03",
      toString: function () {
        return this.url;
      }
    }